export default function WeeklyVolumeChart({
  weeks = [],
  onSelectWeek,
}) {
  const averageSets = weeks.length
    ? Math.round(
      weeks.reduce((sum, week) => sum + week.totalSetCount, 0) / weeks.length
    )
    : 0;

  return (
    <section className="lz-builder-volume" aria-labelledby="lz-builder-volume-title">
      <div className="lz-builder-volume__header">
        <h2 id="lz-builder-volume-title">Weekly Volume <span>(sets)</span></h2>
        <span className="lz-builder-volume__average">Avg: {averageSets}</span>
      </div>
      <div
        className="lz-builder-volume__plot"
        style={{ "--lz-builder-week-count": Math.max(1, weeks.length) }}
      >
        {weeks.map((week, index) => (
          <button
            key={week.weekNumber}
            type="button"
            onClick={() => onSelectWeek?.(week.weekNumber)}
            className={[
              "lz-builder-volume__column",
              week.isSelected ? "lz-builder-volume__column--selected" : "",
            ].filter(Boolean).join(" ")}
            aria-label={`Select week ${week.weekNumber} volume: ${week.totalSetCount} sets`}
            aria-current={week.isSelected ? "true" : undefined}
          >
            <span className="lz-builder-volume__bar-track">
              <span
                className="lz-builder-volume__bar"
                style={{
                  height: week.width,
                  "--lz-builder-volume-grow-delay": `${index * 30}ms`,
                }}
              />
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
